import { Component, OnInit } from '@angular/core';
import { UserLogin, AuthProvider } from '../../providers/auth';
import { Router } from '@angular/router';
import { Utils } from '../../providers/utils';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    private _success = new Subject<{ message: string, type: string }>();
    alertData: {
        message: string,
        type: string
    } = {
            message: '',
            type: 'success'
        }
    userLogin: UserLogin = new UserLogin();
    showSplash: boolean = false;
    banMessage: string = null;

    constructor(public _auth: AuthProvider, public router: Router, public _utils: Utils) {
        /* if(this._auth.redirectUrl == '')
            this.showSplash = this._auth.isLoggedIn;
        console.log(this._auth.redirectUrl); */
        this._auth.loginEmitter.subscribe(url => {
            if (this._auth.userLoggend.baneado) {
                this._success.next({ message: 'No tienes permiso para acceder a la aplicación. Contacta con el administrador', type: 'danger' });
                this.banMessage = 'No tienes permiso para acceder a la aplicación. Contacta con el administrador';
                setTimeout(() => {
                    this.showSplash = true;
                    setTimeout(() => {
                        this._auth.logout();
                    }, 10000);
                }, 4000);
            } else {
                if (url)
                    this.router.navigate([url]);
                else
                    this.router.navigate(['dashboard']);
            }
        });

        this._auth.logoutEmitter.subscribe(result => {
            console.log(result);
            if(result.baned)
                this._success.next({ message: 'No tienes permiso para acceder a la aplicación. Contacta con el administrador', type: 'danger' });
            // this.showSplash = false;
        });
    }

    ngOnInit() {
        this._success.subscribe((alert) => {
            this.alertData.message = alert.message;
            this.alertData.type = alert.type;
        });
        this._success.pipe(
            debounceTime(5000)
        ).subscribe(() => this.alertData.message = null);
    }

    onSubmitLogin() {
        if (this.userLogin.email != '' && this._utils.checkEmail(this.userLogin.email) && this.userLogin.pass != '') {
            this._auth.signInWithEmailAndPass(this.userLogin).then(success => {
                this._success.next({ message: 'login success', type: 'success' });
            }).catch(err => {
                this._success.next({ message: 'No hay registro de usuario correspondiente con estas credenciales. El usuario puede haber sido eliminado.', type: 'danger' });
            })
        } else {
            this._success.next({ message: 'No son validas las credenciales. Compruebe los datos', type: 'danger' });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts